import styled from "@emotion/styled";
import { spacing } from "@hubble/tokens/web";

export const ContainerWrapper = styled.div<{
  textAlign?: string;
  maxWidth?: string;
}>`
  padding: 0 ${spacing[24]};
  box-sizing: border-box;
  margin: 0 auto;
  ${({ maxWidth }) => `
  width: 100%;
  max-width: ${maxWidth || "1126px"};
  `};
  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};
`;
